module.exports = __webpack_public_path__ + "5b30ac371dab92ad9ca05a355a2988ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/search.svg
// module id = 779
// module chunks = 0